/**
 * Constantes e labels para a página de DRE (Demonstração do Resultado do Exercício).
 * MONTH_LABELS e MONTH_SHORT_LABELS são importados de global.js
 */
import { MONTH_LABELS, MONTH_SHORT_LABELS } from "../../../constants/calendar";;

// Re-exportar para que imports existentes dentro do módulo DRE continuem funcionando
export { MONTH_LABELS, MONTH_SHORT_LABELS };

export const VIEW_MODES = {
    MONTHLY: "monthly",
    QUARTERLY: "quarterly",
    ANNUAL: "annual",
};

export const VIEW_MODE_OPTIONS = [
    { value: VIEW_MODES.MONTHLY, label: "Mensal" },
    { value: VIEW_MODES.QUARTERLY, label: "Trimestral" },
    { value: VIEW_MODES.ANNUAL, label: "Anual" },
];

/**
 * Gera a lista de anos disponíveis (últimos 3 anos + próximo).
 */
export const getAvailableYears = () => {
    const currentYear = new Date().getFullYear();
    return [
        { value: currentYear - 2, label: `${currentYear - 2}` },
        { value: currentYear - 1, label: `${currentYear - 1}` },
        { value: currentYear, label: `${currentYear}` },
        { value: currentYear + 1, label: `${currentYear + 1}` },
    ];
};
